import { c as e } from "react/compiler-runtime";
import { BrowserAuthError as t, BrowserAuthErrorCodes as n, InteractionRequiredAuthError as r, InteractionStatus as i, InteractionType as a, LogLevel as o, createStandardPublicClientApplication as s } from "@azure/msal-browser";
import { MsalAuthenticationTemplate as c, MsalProvider as l, useMsal as u } from "@azure/msal-react";
import { createContext as d, useContext as f, useEffect as p, useState as m } from "react";
import { createPortal as h } from "react-dom";
import { Fragment as g, jsx as _, jsxs as v } from "react/jsx-runtime";
import y from "axios";
//#region src/config/Config.ts
var b = {
	Local: "local",
	Dev: "dev",
	Stg: "stg",
	Prd: "prd"
}, x = (e) => {
	let t = new URL(e).hostname;
	return t === "localhost" || t === "127.0.0.1" ? b.Local : t.startsWith("dev.") ? b.Dev : t.startsWith("stg.") ? b.Stg : b.Prd;
}, S = (e) => e !== b.Prd, C = (e, t) => {
	let n = e.VITE_REACT_APP_BRANCH_DEPLOYMENT === "true", r = n ? `${t}/redirect.html` : e.VITE_REACT_APP_ENV_SIGNIN_PREFIX, i = Object.entries(e).filter(([e]) => e.startsWith("VITE_REACT_APP_LOCAL_SERVICE_URI_")), a = {};
	for (let [e, t] of i) t && (a[e.replace("VITE_REACT_APP_LOCAL_SERVICE_URI_", "").toLowerCase()] = t);
	return {
		authClientId: e.VITE_REACT_APP_AUTH_CLIENT_ID,
		authInstance: e.VITE_REACT_APP_AUTH_INSTANCE,
		authDomain: e.VITE_REACT_APP_AUTH_DOMAIN,
		authSignupSigninPolicyId: e.VITE_REACT_APP_AUTH_SIGNIN_SIGNUP_POLICY_ID,
		envSigninPrefix: r,
		environment: n ? b.Dev : x(r),
		authEnableLogs: e.VITE_REACT_APP_LOG_AUTH,
		baseApiUri: e.VITE_REACT_APP_AGENTX_BASE_API,
		authAppUri: e.VITE_REACT_APP_AGENTX_AUTH_APP_URI,
		devMode: e.VITE_REACT_APP_DEV_MODE === "true",
		userIdClaim: e.VITE_REACT_APP_USERID_CLAIM,
		userTypeClaim: e.VITE_REACT_APP_USERTYPE_CLAIM,
		agencyClaim: e.VITE_REACT_APP_AGENCY_CLAIM,
		organisationIdClaim: e.VITE_REACT_APP_ORGANISATION_ID_CLAIM,
		rolesClaim: e.VITE_REACT_APP_ROLES_CLAIM,
		accessScopesClaim: e.VITE_REACT_APP_ACCESS_SCOPES_CLAIM,
		permissionsClaim: e.VITE_REACT_APP_PERMISSIONS_CLAIM,
		localUris: i.length > 0 ? a : void 0
	};
}, w = d({
	getAuthToken: async () => {
		throw Error("getAuthToken not initialized");
	},
	logout: async () => {
		throw Error("logout not initialized");
	},
	userAccount: {}
}), T = "AuthenticationStatus_page__8j2p0u0", E = "AuthenticationStatus_firstPaintOverlay__8j2p0u1 AuthenticationStatus_page__8j2p0u0", D = "AuthenticationStatus_content__8j2p0u2", O = "AuthenticationStatus_icon__8j2p0u3", k = "AuthenticationStatus_title__8j2p0u4", A = "AuthenticationStatus_message__8j2p0u5", j = "AuthenticationStatus_action__8j2p0u6", ee = {
	alert: E,
	status: T
}, M = (t) => {
	let n = e(7), { children: r, role: i } = t, a = ee[i], o = i === "alert" ? "assertive" : "polite", s;
	n[0] === r ? s = n[1] : (s = /* @__PURE__ */ _("section", {
		className: D,
		children: r
	}), n[0] = r, n[1] = s);
	let c;
	return n[2] !== i || n[3] !== a || n[4] !== o || n[5] !== s ? (c = /* @__PURE__ */ _("main", {
		className: a,
		role: i,
		"aria-live": o,
		children: s
	}), n[2] = i, n[3] = a, n[4] = o, n[5] = s, n[6] = c) : c = n[6], c;
}, te = (t) => {
	let n = e(4), { message: r } = t, i, a;
	n[0] === Symbol.for("react.memo_cache_sentinel") ? (i = /* @__PURE__ */ v("svg", {
		"aria-hidden": "true",
		width: "48",
		height: "48",
		viewBox: "0 0 48 48",
		fill: "none",
		className: O,
		xmlns: "http://www.w3.org/2000/svg",
		children: [
			/* @__PURE__ */ _("path", {
				d: "M24 4a20 20 0 1 0 0 40 20 20 0 0 0 0-40Zm0 36a16 16 0 1 1 0-32 16 16 0 0 1 0 32Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _("path", {
				d: "M24 34a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _("path", {
				d: "M24 14a2 2 0 0 0-2 2v10a2 2 0 1 0 4 0V16a2 2 0 0 0-2-2Z",
				fill: "currentColor"
			})
		]
	}), a = /* @__PURE__ */ _("h1", {
		className: k,
		children: "Unable to sign in"
	}), n[0] = i, n[1] = a) : (i = n[0], a = n[1]);
	let o = r ?? "We couldn't complete your sign-in. Please try again.", s;
	return n[2] === o ? s = n[3] : (s = /* @__PURE__ */ v(g, { children: [
		i,
		a,
		/* @__PURE__ */ _("p", {
			className: A,
			children: o
		})
	] }), n[2] = o, n[3] = s), s;
}, N = (e, t) => {
	let n = t, r = "unknown_error";
	typeof n?.errorCode == "string" ? r = n.errorCode : t instanceof Error && (r = t.name), console.error(e, {
		errorCode: r,
		subError: typeof n?.subError == "string" ? n.subError : void 0,
		correlationId: typeof n?.correlationId == "string" ? n.correlationId : void 0
	});
}, P = () => {
	let t = e(1), n;
	return t[0] === Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ _(M, {
		role: "status",
		children: /* @__PURE__ */ _("p", {
			className: A,
			children: "Signing in..."
		})
	}), t[0] = n) : n = t[0], n;
}, ne = () => {
	let t = e(1), n;
	return t[0] === Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ _(M, {
		role: "status",
		children: /* @__PURE__ */ _("p", {
			className: A,
			children: "Logging out..."
		})
	}), t[0] = n) : n = t[0], n;
}, re = ({ onSignOut: e }) => {
	let [t, n] = m(!1), [r, i] = m(!1), a = async () => {
		n(!0), i(!1);
		try {
			await e();
		} catch (e) {
			N("Sign-out failed", e), i(!0);
		} finally {
			n(!1);
		}
	};
	return /* @__PURE__ */ v(M, {
		role: "alert",
		children: [
			/* @__PURE__ */ _("h1", {
				className: k,
				children: "Access denied"
			}),
			/* @__PURE__ */ _("p", {
				className: A,
				children: "This account does not have access to this portal."
			}),
			/* @__PURE__ */ _("button", {
				type: "button",
				className: j,
				disabled: t,
				"aria-busy": t,
				onClick: () => void a(),
				children: t ? "Signing out..." : "Sign out"
			}),
			r && /* @__PURE__ */ _("p", {
				role: "status",
				children: "Sign-out failed. Please try again."
			})
		]
	});
}, F = ({ message: e, onTryAgain: t }) => {
	let [n, r] = m(!1), [i, a] = m(!1), o = async () => {
		r(!0), a(!1);
		try {
			await t();
		} catch (e) {
			N("Authentication recovery failed", e), a(!0);
		} finally {
			r(!1);
		}
	};
	return h(/* @__PURE__ */ v(M, {
		role: "alert",
		children: [
			/* @__PURE__ */ _(te, { message: e }),
			/* @__PURE__ */ _("button", {
				type: "button",
				"aria-busy": n,
				disabled: n,
				className: j,
				onClick: () => void o(),
				children: n ? "Trying again..." : "Try again"
			}),
			i && /* @__PURE__ */ _("p", {
				role: "status",
				className: "AuthenticationStatus_message__8j2p0u5",
				children: "Sign-in could not be restarted. Please try again."
			})
		]
	}), document.body);
}, ie = (e, a, o) => {
	let s, c = i.None;
	return {
		getAuthToken: async () => {
			let l = {
				scopes: o,
				account: e
			};
			try {
				try {
					return (await a.acquireTokenSilent(l)).accessToken;
				} catch (e) {
					if (!(e instanceof t) || e.errorCode !== n.timedOut) throw e;
					return (await a.acquireTokenSilent(l)).accessToken;
				}
			} catch (e) {
				throw e instanceof r ? (!s && c === i.None && (s = a.acquireTokenRedirect(l).finally(() => {
					s = void 0;
				})), s && await s, e) : e;
			}
		},
		setInteractionStatus: (e) => {
			c = e;
		}
	};
}, ae = "https://login.microsoftonline.com/common/oauth2/v2.0/logout", oe = (t) => {
	let n = e(26), { account: r, children: i, inProgress: a, instance: o, scopes: s } = t, c;
	n[0] !== r || n[1] !== o || n[2] !== s ? (c = ie(r, o, s), n[0] = r, n[1] = o, n[2] = s, n[3] = c) : c = n[3];
	let l = c;
	l.setInteractionStatus(a);
	let u = l.getAuthToken, d;
	n[4] !== r || n[5] !== o ? (d = () => o.logoutRedirect({
		account: r,
		postLogoutRedirectUri: ae
	}), n[4] = r, n[5] = o, n[6] = d) : d = n[6];
	let f = d, p = r.idTokenClaims, m = p?.given_name, h = p?.family_name, g = `${p?.given_name} ${p?.family_name}`, v = p?.userId, y = p?.userType, b = p?.agent, x = p?.agency, S = p?.organisationId, C = p?.roles, T = p?.accessScopes, E = p?.permissions, D;
	n[7] !== S || n[8] !== C || n[9] !== T || n[10] !== E || n[11] !== m || n[12] !== h || n[13] !== g || n[14] !== v || n[15] !== y || n[16] !== b || n[17] !== x ? (D = {
		firstName: m,
		lastName: h,
		fullName: g,
		user: v,
		userType: y,
		agent: b,
		agency: x,
		organisationId: S,
		roles: C,
		accessScopes: T,
		permissions: E
	}, n[7] = S, n[8] = C, n[9] = T, n[10] = E, n[11] = m, n[12] = h, n[13] = g, n[14] = v, n[15] = y, n[16] = b, n[17] = x, n[18] = D) : D = n[18];
	let O = D, k;
	n[19] !== u || n[20] !== f || n[21] !== O ? (k = {
		getAuthToken: u,
		logout: f,
		userAccount: O
	}, n[19] = u, n[20] = f, n[21] = O, n[22] = k) : k = n[22];
	let A = k, j;
	return n[23] !== A || n[24] !== i ? (j = /* @__PURE__ */ _(w.Provider, {
		value: A,
		children: i
	}), n[23] = A, n[24] = i, n[25] = j) : j = n[25], j;
}, se = (t) => {
	let n = e(33), { children: r, scopes: i } = t, { accounts: a, inProgress: o, instance: s } = u(), c;
	n[0] === s ? c = n[1] : (c = s.getActiveAccount(), n[0] = s, n[1] = c);
	let l = c, d;
	if (n[2] !== a || n[3] !== l) {
		if (l) {
			let e;
			n[5] === l ? e = n[6] : (e = (e) => e.homeAccountId === l.homeAccountId && e.localAccountId === l.localAccountId && e.username === l.username, n[5] = l, n[6] = e), d = a.find(e);
		} else a.length === 1 && (d = a[0]);
		n[2] = a, n[3] = l, n[4] = d;
	} else d = n[4];
	let f;
	n[7] !== a[0] || n[8] !== a.length || n[9] !== l || n[10] !== s ? (f = () => {
		!l && a.length === 1 && s.setActiveAccount(a[0]);
	}, n[7] = a[0], n[8] = a.length, n[9] = l, n[10] = s, n[11] = f) : f = n[11];
	let m;
	n[12] !== a || n[13] !== l || n[14] !== s ? (m = [
		a,
		l,
		s
	], n[12] = a, n[13] = l, n[14] = s, n[15] = m) : m = n[15], p(f, m);
	let h;
	n[16] !== d || n[17] !== a.length ? (h = () => {
		!d && a.length > 1 && console.error("Authentication account selection failed", {
			errorCode: "multiple_cached_accounts",
			subError: "active_account_missing",
			correlationId: void 0
		});
	}, n[16] = d, n[17] = a.length, n[18] = h) : h = n[18];
	let g;
	n[19] !== d || n[20] !== a.length ? (g = [d, a.length], n[19] = d, n[20] = a.length, n[21] = g) : g = n[21], p(h, g);
	let v;
	n[22] !== s || n[23] !== i ? (v = async () => {
		await s.clearCache(), await s.loginRedirect({
			scopes: i,
			prompt: "login"
		});
	}, n[22] = s, n[23] = i, n[24] = v) : v = n[24];
	let y = v;
	if (!d) {
		let e;
		return n[25] === y ? e = n[26] : (e = /* @__PURE__ */ _(F, { onTryAgain: y }), n[25] = y, n[26] = e), e;
	}
	let b;
	return n[27] !== d || n[28] !== r || n[29] !== o || n[30] !== s || n[31] !== i ? (b = /* @__PURE__ */ _(oe, {
		account: d,
		inProgress: o,
		instance: s,
		scopes: i,
		children: r
	}), n[27] = d, n[28] = r, n[29] = o, n[30] = s, n[31] = i, n[32] = b) : b = n[32], b;
}, I = d(void 0), ce = (t) => {
	let n = e(2), { inProgress: r } = t, a;
	return n[0] === r ? a = n[1] : (a = r === i.Logout ? /* @__PURE__ */ _(ne, {}) : /* @__PURE__ */ _(P, {}), n[0] = r, n[1] = a), a;
}, L = () => {
	let e = f(I);
	if (!e) throw Error("Authentication request is not initialized");
	return e;
}, R = (t) => {
	let n = e(10), { error: r, login: i } = t, { instance: o } = u(), s = L(), c, l;
	n[0] === r ? (c = n[1], l = n[2]) : (c = () => {
		N("Authentication failed", r);
	}, l = [r], n[0] = r, n[1] = c, n[2] = l), p(c, l);
	let d;
	n[3] !== s || n[4] !== o || n[5] !== i ? (d = async () => {
		await o.clearCache(), await i(a.Redirect, {
			...s,
			prompt: "login"
		});
	}, n[3] = s, n[4] = o, n[5] = i, n[6] = d) : d = n[6];
	let f = d, m = r?.errorMessage, h;
	return n[7] !== f || n[8] !== m ? (h = /* @__PURE__ */ _(F, {
		message: m,
		onTryAgain: f
	}), n[7] = f, n[8] = m, n[9] = h) : h = n[9], h;
}, z = ({ authClientId: e, authInstance: t, authDomain: n, authSignupSigninPolicyId: r, envSigninPrefix: i, authEnableLogs: a }) => {
	if (!e) throw Error("authClientId is not set");
	if (!t) throw Error("authInstance is not set");
	if (!n) throw Error("authDomain is not set");
	if (!r) throw Error("authSignupSigninPolicyId is not set");
	if (!i) throw Error("envSigninPrefix is not set");
	let s;
	try {
		s = new URL(i);
	} catch {
		throw Error("envSigninPrefix must be an absolute URL ending in /redirect.html");
	}
	if (!s.pathname.endsWith("/redirect.html") || s.search !== "" || s.hash !== "") throw Error("envSigninPrefix must be an absolute URL ending in /redirect.html");
	let c = a === "true";
	return {
		auth: {
			clientId: e,
			authority: `https://${t}/${n}/${r}`,
			knownAuthorities: [t],
			redirectUri: s.href
		},
		cache: { cacheLocation: "localStorage" },
		system: { loggerOptions: { loggerCallback: (e, t, n) => {
			if (c && !n) switch (e) {
				case o.Error:
					console.error(t);
					return;
				case o.Info:
					console.info(t);
					return;
				case o.Verbose:
					console.debug(t);
					return;
				case o.Warning:
					console.warn(t);
					return;
				default: return;
			}
		} } }
	};
}, B = ({ userIdClaim: e, userTypeClaim: t, agencyClaim: n, organisationIdClaim: r, rolesClaim: i, accessScopesClaim: a, permissionsClaim: o }) => ({
	firstName: "Local",
	lastName: "User",
	fullName: "Local User",
	user: e,
	userType: t,
	agent: t?.toLowerCase() === "platform" ? void 0 : e,
	agency: n,
	organisationId: r,
	roles: i?.split(",").map((e) => e.trim()).filter(Boolean),
	accessScopes: a?.split(",").map((e) => e.trim()).filter(Boolean),
	permissions: o?.split(",").map((e) => e.trim()).filter(Boolean)
}), V = (t) => {
	let n = e(7), { children: r, apiConfig: i } = t, a = le, o = ue, s;
	n[0] === i ? s = n[1] : (s = B(i), n[0] = i, n[1] = s);
	let c = s, l;
	n[2] === c ? l = n[3] : (l = {
		getAuthToken: a,
		logout: o,
		userAccount: c
	}, n[2] = c, n[3] = l);
	let u = l, d;
	return n[4] !== u || n[5] !== r ? (d = /* @__PURE__ */ _(w.Provider, {
		value: u,
		children: r
	}), n[4] = u, n[5] = r, n[6] = d) : d = n[6], d;
}, H = ({ children: e, apiConfig: t }) => {
	let [n, r] = m(), [i, o] = m(!1);
	return p(() => {
		let e = (e) => {
			N("Failed to initialize authentication", e), o(!0);
		};
		try {
			if (!t.authAppUri) throw Error("authAppUri is not set");
			let n = { scopes: [`${t.authAppUri}/openid`] };
			s(z(t)).then((e) => r({
				instance: e,
				authenticationRequest: n
			}), e);
		} catch (t) {
			e(t);
		}
	}, [t]), i ? /* @__PURE__ */ _(F, { onTryAgain: () => window.location.reload() }) : n ? /* @__PURE__ */ _(l, {
		instance: n.instance,
		children: /* @__PURE__ */ _(I.Provider, {
			value: n.authenticationRequest,
			children: /* @__PURE__ */ _(c, {
				interactionType: a.Redirect,
				authenticationRequest: n.authenticationRequest,
				loadingComponent: ce,
				errorComponent: R,
				children: /* @__PURE__ */ _(se, {
					scopes: n.authenticationRequest.scopes,
					children: e
				})
			})
		})
	}) : /* @__PURE__ */ _(P, {});
}, U = (t) => {
	let n = e(2), { children: r, scope: i } = t, { userAccount: a, logout: o } = f(w);
	if (i && !a.accessScopes?.includes(i)) {
		let e;
		return n[0] === o ? e = n[1] : (e = /* @__PURE__ */ _(re, { onSignOut: o }), n[0] = o, n[1] = e), e;
	}
	return r;
}, W = (t) => {
	let n = e(9), { children: r, apiConfig: i, requiredAccessScope: a } = t, o;
	n[0] !== r || n[1] !== a ? (o = /* @__PURE__ */ _(U, {
		scope: a,
		children: r
	}), n[0] = r, n[1] = a, n[2] = o) : o = n[2];
	let s = o;
	if (i.devMode && i.userIdClaim && i.userTypeClaim) {
		let e;
		return n[3] !== i || n[4] !== s ? (e = /* @__PURE__ */ _(V, {
			apiConfig: i,
			children: s
		}), n[3] = i, n[4] = s, n[5] = e) : e = n[5], e;
	}
	let c;
	return n[6] !== i || n[7] !== s ? (c = /* @__PURE__ */ _(H, {
		apiConfig: i,
		children: s
	}), n[6] = i, n[7] = s, n[8] = c) : c = n[8], c;
};
async function le() {
	return "local-dev-auth";
}
async function ue() {}
//#endregion
//#region src/api/MaintenanceMode.ts
var G = "maintenance-mode-until", de = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}Z$/, K = "/", fe = (e) => {
	let t = e.headers?.[G];
	if (t === void 0) return;
	if (typeof t != "string" || !de.test(t)) throw Error(`${G} must be a UTC timestamp in YYYY-MM-DDTHH:mm:ssZ format`);
	let n = Date.parse(t);
	if (Number.isNaN(n) || new Date(n).toISOString().replace(".000Z", "Z") !== t) throw Error(`${G} must be a valid UTC timestamp in YYYY-MM-DDTHH:mm:ssZ format`);
	return t;
}, q = (e) => {
	let t = fe(e);
	if (!t) return !1;
	let n = new URL(`${K}maintenance.html`, globalThis.location.origin);
	return n.searchParams.set(G, t), globalThis.location.replace(`${n.pathname}${n.search}`), !0;
}, J = () => new Promise(() => void 0), pe = (e, t = "/") => (K = t, e.interceptors.response.use((e) => q(e) ? J() : Promise.resolve(e), (e) => y.isAxiosError(e) && e.response && q(e.response) ? J() : Promise.reject(e))), Y = "autopilot-sessionId", X = () => {
	let e = crypto.randomUUID();
	return sessionStorage.setItem(Y, e), e;
}, Z = () => sessionStorage.getItem("autopilot-sessionId") || X(), Q = /* @__PURE__ */ new WeakMap(), me = (e) => typeof e == "object" && e ? Q.get(e) : void 0, he = ({ userIdClaim: e, userTypeClaim: t, agencyClaim: n, organisationIdClaim: r, rolesClaim: i, accessScopesClaim: a, permissionsClaim: o }) => {
	let s = {};
	return e !== void 0 && (s["x-claim-userId"] = e), t !== void 0 && (s["x-claim-userType"] = t), n !== void 0 && (s["x-claim-agency"] = n), r !== void 0 && (s["x-claim-organisationId"] = r), i !== void 0 && (s["x-claim-roles"] = i), a !== void 0 && (s["x-claim-accessScopes"] = a), o !== void 0 && (s["x-claim-permissions"] = o), s;
}, ge = class {
	getAuthTokenFunction = void 0;
	devHeaders = {};
	constructor() {}
	transformOptions = async (e) => {
		if (!this.getAuthTokenFunction) throw Error("No getAuthTokenFunction has been provided");
		let t = await this.getAuthTokenFunction();
		return e.headers = {
			...e.headers,
			...this.devHeaders,
			"x-session-id": Z(),
			Authorization: `Bearer ${t}`
		}, Promise.resolve(e);
	};
	setAuthConfig = (e, t) => {
		this.getAuthTokenFunction = e, this.devHeaders = he(t);
	};
	async transformResult(e, t, n) {
		if (q(t)) return await new Promise(() => void 0);
		let r = String(t.headers?.["content-type"] ?? "").toLowerCase(), i = t.data;
		if (t.status >= 200 && t.status < 300 && r.includes("application/json") && typeof i == "object" && i) return i;
		try {
			return await n(t);
		} catch (e) {
			throw typeof e == "object" && e && Q.set(e, t.status), e;
		}
	}
}, $ = /* @__PURE__ */ function(e) {
	return e.Director = "director", e.SalesAgent = "salesagent", e.Admin = "admin", e;
}({}), _e = /* @__PURE__ */ function(e) {
	return e.BusinessManager = "businessmanager", e.AdminManager = "adminmanager", e.MarketingExpert = "marketingexpert", e.ListingsContributor = "listingscontributor", e.LaunchContributor = "launchcontributor", e.ContractsContributor = "contractscontributor", e.TransactionsContributor = "transactionscontributor", e.FinanceContributor = "financecontributor", e.WorkflowContributor = "workflowcontributor", e.Executive = "executive", e.SuperAdmin = "superadmin", e;
}({}), ve = /* @__PURE__ */ function(e) {
	return e.Agency = "agency", e.Organisation = "organisation", e.Platform = "platform", e;
}({});
//#endregion
export { ve as AccessScope, $ as AgentRole, W as AgxAuth, b as AgxEnvironments, w as AuthContext, ge as AuthorizedApiBase, Y as BROWSER_SESSION_STORAGE_KEY, G as MAINTENANCE_MODE_UNTIL_HEADER, _e as StaffRole, C as createAgxConfig, me as getApiErrorStatus, Z as getBrowserSessionId, S as isNonProductionEnvironment, q as redirectToMaintenancePage, pe as registerMaintenanceModeInterceptor, x as resolveAgxEnvironment, X as startBrowserSession };

//# sourceMappingURL=index.js.map